import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { useDispatch, useSelector } from "react-redux";
import { editStep, saveSteps } from "../redux/slices/step/stepSlice";

function uploadImageCallBack(file) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://api.imgur.com/3/image");
    xhr.setRequestHeader("Authorization", "Client-ID XXXXX");
    const data = new FormData();
    data.append("image", file);
    xhr.send(data);
    xhr.addEventListener("load", () => {
      const response = JSON.parse(xhr.responseText);
      resolve(response);
    });
    xhr.addEventListener("error", () => {
      const error = JSON.parse(xhr.responseText);
      reject(error);
    });
  });
}

function EditorContainer(props) {
  const onContentStateChange = (contentState) => {
    const data = { step: contentState, element: currentStep };
    dispatch(editStep(data));
  };
  const Steps: any[] = useSelector((state) => state.step.data);
  const currentStep = useSelector((state) => state.step.currentStep);
  const filteredArray: any = Steps.filter((step) => step.id === currentStep);
  const dispatch = useDispatch();

  function submit() {
    console.log(props);
    const product = props.props.filteredArray;
    const steps = props.props.steps;
    const data = { product, steps };
    dispatch(saveSteps(data)); //send to a serialiser that edits all steps and saves information into them using PUT/PATCH
  }

  function nextStep() {} //changes state to ID that is referenced in Target of connection
  function prevStep() {} //changes currentStep to ID that is referenced in Source of connection
  function startStep() {} //changes currentStep to starting element ID
  function endStep() {} //changes to final element ID

  return (
    <div className="editor">
      <Editor
        toolbar={{
          inline: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          link: { inDropdown: true },
          history: { inDropdown: true },
          image: {
            uploadCallback: uploadImageCallBack,
            alt: { present: true, mandatory: true },
          },
        }}
        onContentStateChange={onContentStateChange}
      />
      <textarea
        value={JSON.stringify(
          filteredArray.map((filtered) => filtered.step),
          null,
          4
        )}
      />
      <button onClick={submit}>Save</button>
      <button onClick={nextStep}>next step</button>
      <button onClick={prevStep}>previous step</button>
      <button onClick={startStep}>go to start</button>
      <button onClick={endStep}>go to end</button>
    </div>
  );
}

export default EditorContainer;
